export default __webpack_public_path__ + "static/ES-Logo-4f2992ae7a14834701412cb3d142f18f.jpeg";